import { BlockOverrides } from 'baseui/block';
import { StyleObject } from 'styletron-react';

export const NAME: BlockOverrides = {
  Block: {
    style: {
      marginTop: 0,
      marginBottom: 0,
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      cursor: 'pointer',
    },
  },
};

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      marginBottom: '16px',
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gridColumnGap: '64px',
      alignItems: 'center',
    },
  },
};

export const DIV: StyleObject = {
  width: '100%',

  ':hover': {
    textDecoration: 'underline',
  },
};
